import { arrayOf, number, object, string } from 'prop-types';
import Head from 'next/head';
import React, { Fragment } from 'react';
import { AMP_RUBICON_SRID } from 'constants/ads/prebid';
import { PERMUTIVE_NAMESPACE } from 'constants/ads/permutive';

function AmpAd(props) {
  const { size, unit, resourceId, refreshInterval } = props;
  const [width, height] = size;
  // Remove GraphQL typename from targeting data
  const { __typename, ...targeting } = props.targeting;
  const srid = AMP_RUBICON_SRID[unit];
  const rtc = {
    vendors: {
      aps: {
        PUB_ID: '3389',
        PARAMS: { amp: '1' }
      },
      ...(srid
        ? {
            prebidrubicon: {
              REQUEST_ID: srid
            }
          }
        : undefined)
    },
    urls: [
      `https://${PERMUTIVE_NAMESPACE}.amp.permutive.com/rtc?type=doubleclick`
    ]
  };
  return (
    <Fragment>
      <Head>
        <script
          async
          key="amp-ad"
          custom-element="amp-ad"
          src="https://cdn.ampproject.org/v0/amp-ad-0.1.js"
        />
      </Head>
      <amp-ad
        width={width}
        height={height}
        type="doubleclick"
        data-slot={unit}
        data-loading-strategy="prefer-viewability-over-views"
        data-enable-refresh={refreshInterval}
        json={JSON.stringify({
          targeting: {
            ...targeting,
            // Add post id targeting
            post_id: resourceId
          }
        })}
        rtc-config={JSON.stringify(rtc)}
      />
    </Fragment>
  );
}

AmpAd.defaultProps = {
  targeting: {},
  resourceId: '',
  size: [300, 250],
  refreshInterval: undefined
};

AmpAd.propTypes = {
  unit: string.isRequired,
  targeting: object, // eslint-disable-line
  resourceId: string,
  size: arrayOf(number),
  refreshInterval: number
};

export default AmpAd;
